import { useTranslate } from '@tolgee/react';
import { getStoreCount, StoreScopes } from 'components/StoreScopes';
import { css } from '@emotion/css';
import { Select, Tag } from 'antd';
import { useState, memo, useEffect } from 'react';
import { useStoreScope } from './state';
import { useStoreLimitContext } from '@knowledge/common/components/ItemSelectV2/context';
import { useScopedStores } from '@knowledge/common/components/ItemSelectV2/useScopedStores';

function StoreSelect() {
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const [storeScopes, setStoreScopes] = useStoreScope();
  const { storeScopes: defaultStoreScopes, initialStoreScopes, sideStore } = useStoreLimitContext();
  const storeDataSource = useScopedStores(defaultStoreScopes);
  useEffect(() => {
    if (initialStoreScopes) {
      setStoreScopes(initialStoreScopes);
    }
  }, [setStoreScopes, initialStoreScopes]);

  return sideStore ? (
    <></>
  ) : (
    <Select
      mode="multiple"
      showSearch={false}
      placeholder={t('remind.选择店铺')}
      value={storeScopes?.length ? ['placeholder'] : []}
      allowClear
      // disabled={defaultStoreScopes?.length > 0}
      onClear={() => {
        setStoreScopes([]);
      }}
      tagRender={() => (
        <Tag>
          {t('department.已选x店铺', {
            x: getStoreCount(storeScopes || []),
          })}
        </Tag>
      )}
      open={visible}
      onDropdownVisibleChange={setVisible}
      placement="bottomLeft"
      dropdownRender={(_menu) =>
        visible ? (
          <StoreScopes
            allowEmpty
            supportWa={false}
            className={css`
              max-height: 95vh;
              overflow-y: auto;
            `}
            value={storeScopes}
            onCancel={() => setVisible(false)}
            showFooterTips={false}
            onChange={(storeScopes) => {
              setStoreScopes(storeScopes);
            }}
            storeDataSource={storeDataSource?.length ? storeDataSource : undefined}
          />
        ) : (
          <></>
        )
      }
      className={css`
        flex: 0 0 180px;
      `}
      dropdownClassName={dropdownClassName}
    />
  );
}

const dropdownClassName = css`
  width: 950px !important;
  overflow-y: auto;
  padding-top: 0;
  padding-bottom: 0;
  color: rgba(0, 0, 0, 0.85);
`;

export default memo(StoreSelect);
